import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../../../service/api";

export default function AssignSalespersonModal({
    show,
    onHide,
    row,
    onUpdated,
    salespersons,
}) {
    const [salespersonId, setSalespersonId] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (row) {
            setSalespersonId(String(row.salesperson_id ?? ""));
        }
    }, [row]);
;

    const handleSubmit = async () => {
        if (!row) return;

        try {
            setLoading(true);

            await api.put(`tms/bank-transaction/update-salesperson/${row.id}`, {
                salesperson_id: salespersonId,
            });

            onUpdated(); // refresh table
            onHide();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSalespersonId("");
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Assign Salesperson</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group>
                    <Form.Label>Salesperson</Form.Label>
                    <Form.Select
                        value={String(salespersonId)}
                        onChange={(e) => setSalespersonId(e.target.value)}
                    >

                        <option value="">Select Salesperson</option>
                        {salespersons.map((sp) => (
                            <option key={sp.value} value={String(sp.value)}>
                                {sp.label}
                            </option>

                        ))}
                    </Form.Select>
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? "Updating..." : "Update"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
